module.exports = __webpack_public_path__ + "img/support_a11.62650842.png";